import React, { Component } from "react"

export class advertisements extends Component {
  render() {
    return (
      <div className="ad-section">
        <div className="ad-story-intro">
          <p>SearchWorld Marketplace was built by <a href="https://njtautomation.com/" target="_blank" rel="noopener" title="NJT Automation">NJT Automation</a> to source hard-to-find industrial components during the chip shortage. We made it free for everyone.</p>
        </div>
        <div className="ad-section-header">
          <span className="ad-badge">Featured Partner</span>
          <h2 className="ad-section-title">Industrial Automation Solutions</h2>
          <p className="ad-section-subtitle">Professional repair services and quality components from NJT Automation</p>
        </div>
        
        <div className="advertisement-container">
          {/* Industrial Electronics Repair Section */}
          <div className="advertisement ad-repair">
            <div className="ad-icon-wrapper">
              <div className="ad-icon">🔧</div>
            </div>
            <div className="ad-badge-inline">Fast Turnaround</div>
            <h3 className="ad-title">
              <a 
                href="https://njtautomation.com/industrial-electronics-repair/" 
                target="_blank" 
                rel="noopener"
                title="Industrial Electronics Repair Services"
              >
                Industrial Electronics Repair
              </a>
            </h3>
            <p className="ad-description">
              Expert mail-in repair services with a <strong>1-year full-function warranty</strong> on all repairs.
            </p>
            <div className="ad-features">
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>HMI & PanelView Repair</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>PLC Repair (Allen-Bradley, Siemens)</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>VFD & Servo Drive Repair</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>24-Hour Rush Available</span>
              </div>
            </div>
            <a
              href="https://njtautomation.com/industrial-electronics-repair/"
              target="_blank"
              rel="noopener"
              className="ad-cta-primary"
              title="Get a repair quote for industrial electronics"
            >
              Get Repair Quote
              <span className="ad-cta-arrow">→</span>
            </a>
          </div>

          {/* Industrial Automation Supply Section */}
          <div className="advertisement ad-supply">
            <div className="ad-icon-wrapper">
              <div className="ad-icon">⚡</div>
            </div>
            <div className="ad-badge-inline">15K+ Parts Sold</div>
            <h3 className="ad-title">
              <a 
                href="https://njtautomation.com/" 
                target="_blank" 
                rel="noopener"
                title="NJT Automation - Industrial Automation Components"
              >
                Industrial Components Supply
              </a>
            </h3>
            <p className="ad-description">
              Quality Allen-Bradley parts with <strong>100% positive rating</strong> and fast shipping.
            </p>
            <div className="ad-features">
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>Allen-Bradley PLCs & Modules</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>PanelView HMIs & Touchscreens</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>PowerFlex VFDs & Servo Drives</span>
              </div>
              <div className="ad-feature">
                <span className="ad-feature-icon">✓</span>
                <span>Next-Day Air Available</span>
              </div>
            </div>
            <a
              href="https://njtautomation.com/"
              target="_blank"
              rel="noopener"
              className="ad-cta-primary"
              title="Shop Allen-Bradley Industrial Components"
            >
              Shop Components
              <span className="ad-cta-arrow">→</span>
            </a>
          </div>
        </div>

        <div className="ad-footer">
          <a 
            href="https://njtautomation.com/" 
            target="_blank" 
            rel="noopener"
            className="ad-footer-link"
            title="Visit NJT Automation"
          >
            Visit NJTAutomation.com
          </a>
          <span className="ad-footer-separator">•</span>
          <span className="ad-footer-text">Milwaukee, WI</span>
        </div>
      </div>
    )
  }
}

export default advertisements
